export const TITLE = 'Question Name';
export const PLACEHOLDER = 'What is also known as the powerhouse of the cell?';
